import { render } from "./PrivateRows.vue?vue&type=template&id=50675037&scoped=true"
import script from "./PrivateRows.vue?vue&type=script&lang=js"
export * from "./PrivateRows.vue?vue&type=script&lang=js"

import "./PrivateRows.vue?vue&type=style&index=0&id=50675037&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50675037"]])

export default __exports__